
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton } from '@/components';
import { useLeagueEdit } from '@/modules/league/model/edit';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';

export default defineComponent({
    name: ROUTE_NAME_LEAGUE.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppDateTimePicker, AppButton },
    setup() {
        const { model, v$, fetch, actions, timeUnits } = useLeagueEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions, timeUnits, ROUTE_NAME_LEAGUE };
    }
});
